
<template>
  <div :class="classes">
    <pt-page-title title="基因实验室订单" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
      <el-button slot="before-left" type="primary" @click="goCreated" v-if="hasCreatelabOrder">创建订单</el-button>
    </pt-page-title>
     <pt-page-factor-filter :labels="filterLabels" :displayVertical="true" v-model="filterForm"  isQueryRouter @Filter="Filter" ref="filter">
        <div :class="$style['buttons']">
          <div>
            <el-button type="primary" @click="handleFilter(false)">筛选</el-button>
            <el-button type="primary" @click="exportExcel" :loading="loading">导出订单</el-button>
            <el-button type="primary" @click="exportHistory">导出历史</el-button>
            <el-button type="primary" @click="filterAbnormal(false)" v-if="isPrimaryUser">超期订单：<big>{{abnormalOrderCount}}</big></el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </div>
          <div>
            <el-button type="primary" :class="$style['button__box']" @click="goOrderHandle"  v-if="isPrimaryUser">异常订单：<big>{{pendingOrderCount}}</big></el-button>
            <el-button type="primary" :class="$style['button__box']" @click="downReports">下载报告</el-button>
            <el-button type="primary" v-if="hasOperateOrder" :class="$style['button__box']" @click="dialogVisible = true">批量操作</el-button>
          </div>
        </div>
      </pt-page-factor-filter>
    <!-- table -->
    <pt-gene-lab-order-table ref="table" @exportSuccess="exportSuccess" @downSuccess="downSuccess" :showFields="showFields" :isFuzzy="isFuzzy" :isFromRouter="isFromRouter" :isShowCheckbox="true" @updateSelectedData="updateSelectedData" :params="params"></pt-gene-lab-order-table>
    <!-- 批量操作选择的dialog -->
    <pt-lot-operate-choice-dialog :dialogVisible="dialogVisible" :handle-close="close"></pt-lot-operate-choice-dialog>
  </div>
</template>

<script>
// 组件class前缀
import ptPageTitle from 'cps/base/pt-page-title'
// import ptGeneLabOrderFilterForm from './pt-gene-lab-order-filter-form/withData'
import ptGeneLabOrderTable from './pt-gene-lab-order-table/withData'
import ptLotOperateChoiceDialog from './pt-lot-operate-choice-dialog'
import { emptyObject } from '@/utils/lifebankUtils'
import { filterFactor } from './lab-order-options.js'
import { hasPermissions } from 'utils/permissions'
const prefixCls = 'pt-gene-lab-order'
// 权限
const PERM_LAB_CREATE_ORDER = 'PERM_LAB_CREATE_ORDER'
export default {
  name: 'pt-gene-lab-order',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    showFields () {
      return ['运输日期', '样本条码号', '生产条码号', '样本类型', '接收日期', '受检人', '性别', '年龄', '检测套餐', '实验室检测平台', '订单来源', '地区', '交付日期', '剩余天数', '待操作', '历史检测', '订单类型', '采集次数', '操作']
    },
    hasCreatelabOrder () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_LAB_CREATE_ORDER)
    },
    hasOperateOrder () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_LAB_OPERATION')
    },
    tableData () {
      return this.$refs.table.tableData
    }
  },
  props: {
    detectionPackageList: {
      type: Array,
      default: function () {
        return []
      }
    },
    areaList: {
      type: Array,
      default: function () {
        return []
      }
    },
    seqTypes: {
      type: Array,
      default: function () {
        return []
      }
    },
    isPrimaryUser: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ptPageTitle,
    // ptGeneLabOrderFilterForm,
    ptGeneLabOrderTable,
    ptLotOperateChoiceDialog
  },
  data () {
    return {
      filterLabels: filterFactor,
      dialogVisible: false,
      // 筛选表单
      filterForm: {},
      abnormalOrderCount: '',
      pendingOrderCount: '',
      searchKey: '',
      isFuzzy: false,
      params: {
        needActionTaskInfo: true,
        pageableParam: { page: 0, size: 10 },
        productIds: [],
        statusTime: [{ startTime: '', endTime: '', orderStatus: 'COMPLETED' }],
        needHistoryOrders: true
      },
      isFromRouter: false,
      selectData: [],
      loading: false,
      downLoading: false
    }
  },
  watch: {
    detectionPackageList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'detectionPackageIds') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    },
    areaList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'businessOriginArea') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    },
    seqTypes: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'sequencingTechnologyTypes') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    },
    isPrimaryUser: {
      handler: function (val) {
        if (val === false) {
          let copy = JSON.parse(JSON.stringify(this.filterLabels))
          copy.forEach((item, index) => {
            if (item.value === 'businessOriginArea') {
              copy.splice(index, 1)
            }
          })
          this.filterLabels = copy
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    exportHistory () {
      this.$router.push('/export-history/lab-order?name=lab_export')
    },
    goCreated () {
      this.$router.push('/lab-order-form/false/0')
    },
    downSuccess () {
      this.downLoading = false
    },
    downReports () {
      if (this.selectData) {
        let newSelectData = this.selectData.filter(e => {
          let reportStatus = e.orderStatusEnum === 'REPORT_CREATED' || e.orderStatusEnum === 'COMPLETED' || e.orderStatusEnum === 'REPORT_CHECKED_1ST'
          if (e.reportOssUrls && e.reportOssUrls.length && reportStatus) {
            return e.id
          }
        })
        this.params.ids = newSelectData.map(item => {
          return item.id
        })
      }
      if (!this.params.ids || !this.params.ids.length) {
        this.$message.error('您所选的订单中均未生成报告，请重新选择')
      } else {
        this.$confirm('下载操作需要花费一定时间，完成下载后我们会将数据保存在“导出历史”中，您稍后下载即可。', '下载提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          this.downLoading = true
          this.$refs.table.downReports(this.params)
        })
      }
    },
    Filter (val) {
      if (!this.searchKey) {
        this.handleFilter(val)
      }
    },
    cleanParams () {
      emptyObject(this.filterForm)
      this.handleFilter(false)
    },
    search (val) {
      this.searchKey = val
      this.isFuzzy = true
      this.isFromRouter = false
      emptyObject(this.filterForm)
      emptyObject(this.params)
      this.params.fuzzyQuery = val
      // this.$store.dispatch('labOrderFuzzy', this.getMatchParams(this.filterForm)).then
      //   this.handleFilter(true)
      this.params.pageableParam = { page: 0, size: 50 }
      this.$nextTick(_ => {
        this.$refs.table.reload(this.params)
      })
    },
    emptySearch () {
      this.filterForm.sampleIds = null
      this.handleFilter(false)
    },
    // reload (params) {
    //   this.$refs.table.reload(params)
    // },
    // handleLoad () {
    //   this.$emit('handleLoad', this.filterForm)
    // }
    close () {
      this.dialogVisible = false
    },
    getMatchParams (data) {
      let newData = {
        salesFroms: data.salesFroms ? [data.salesFroms] : null,
        sequencingTechnologyTypes: data.sequencingTechnologyTypes ? [data.sequencingTechnologyTypes] : null,
        sampleTypes: data.sampleTypes ? [data.sampleTypes] : null,
        businessOriginArea: data.businessOriginArea,
        fuzzyQuery: data.fuzzyQuery,
        needActionTaskInfo: true,
        pageableParam: { page: 0, size: 50 },
        workflow: data.workflow,
        sampleIds: data.sampleIds,
        detectionPackageIds: data.detectionPackageIds,
        statusTime: [{ startTime: data.COMPLETED ? data.COMPLETED.startTime : '', endTime: data.COMPLETED ? data.COMPLETED.endTime : '', orderStatus: 'COMPLETED' }, { startTime: data.operationTime ? data.operationTime.opStartTime : '', endTime: data.operationTime ? data.operationTime.opEndTime : '', orderStatus: data.completeStatus }]
      }
      if (data.targetStatus === 'LAB_SAMPLE_RETURNED' || data.targetStatus === 'COMPLETED') {
        newData.completeStatus = data.targetStatus
      } else {
        newData.targetStatus = data.targetStatus
        delete newData.completeStatus
      }
      if (data.completeStatus) {
        newData.completeStatus = data.completeStatus
      }
      return newData
    },
    handleFilter (isFromRouter) {
      if (!isFromRouter) {
        this.searchKey = null
        this.$delete(this.filterForm, 'isFuzzy')
      }
      this.isFromRouter = isFromRouter

      this.isFuzzy = false
      for (let key in this.filterForm) {
        if (!this.filterForm[key]) {
          this.$delete(this.filterForm, key)
        }
      }
      let params = this.getMatchParams(JSON.parse(JSON.stringify(this.filterForm)))
      this.params = params
      // 传入筛选参数
      if (!isFromRouter && !this.isFuzzy) {
        this.$nextTick(_ => {
          this.$refs.filter.getAddRouter(JSON.parse(JSON.stringify(this.filterForm)))
        })
      }
      this.$nextTick(_ => {
        // this.$refs.table.reload(params)
      })
    },
    filterAbnormal (isSearch) {
      if (!isSearch) {
        this.isFuzzy = false
      }
      let params = this.getMatchParams(this.filterForm)
      params.screenExpiredOrder = true
      this.params = params
      this.$refs.table.reload(params)
    },
    goOrderHandle () {
      // TZ: 不再查询WAITING_FOR_JOB，WAITING_FOR_JOB状态的待处理并不是异常订单
      this.$router.push({ name: 'order-handle', params: { status: 'ACTION_REQUIRED' } })
    },
    getSpecialOrderCount () {
      this.$store.dispatch('getSpecialOrderCount').then(data => {
        this.pendingOrderCount = data.actionRequiredOrderNum
        this.abnormalOrderCount = data.expiredOrderNum
      }).catch(err => {
        this.$message.error(err)
      })
    },
    exportSuccess () {
      this.loading = false
    },
    exportExcel () {
      if (this.selectData) {
        this.params.ids = this.selectData.map(e => e.id)
      }
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          this.loading = true
          this.$refs.table.exportExcel(this.params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }

      // this.selectData = []
    },
    updateSelectedData (data) {
      this.selectData = data
    }
  },
  created () {
    this.getSpecialOrderCount()
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.buttons{
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.button__box{
   width:160px;
   >big{
     font-size: 18px;
     font-weight: bold;
   }
}
</style>
